<template>
  <div>

    <modal_search_alert
        class="abtg-modal-search-alert"
        :isZoneUpdateAlert="isZoneUpdateAlert"
        @before-close="SET_DATA({ name: 'showSearchAlertModal', data: false })"
        @closeModal="closeAndResetModal"
    ></modal_search_alert>

    <n-bread v-bind:content="{ bread_list, bread_active }"></n-bread>

    <n-gmap
        @checkCredit="checkCredit"
        @click-button="searchGoogleMap"
        @prepare-data="prepareDataToSend"
        :key="componentKey"
        v-if="zoneInfo"
        v-bind:content="{
        zoneInfo: zoneInfo,
        zoneListOfCity: null,
        showGoogleMap: true,
        origin: origin,
        pathBack: pathBack,
        showToolToUseForMapping: true,
        searchType: searchType,
        buildingTypes: buildingTypes,
        monthlyCounter: monthlyCounter,
        monthlyZoneCounter: monthlyZoneCounter,
        isWalletFull:isWalletFull,
        checkBoxWallet: checkBoxWallet,
      }"
    ></n-gmap>

    <!--    <div style="margin-top:10px; margin-bottom:10px;width:100%;padding:5px;background-color:yellow;color:black">A causa di un crash del portale immobiliare.it, Real Estate Pro cercherà gli annunci solo su idealista.it, fino a quando il sito immobliare.it non tornerà a funzionare.</div>-->
    <div class="row" v-if="showCard">
      <div class="col-md-12">
        <div class="card abtg__default-card abtg__default-card-border">
          <div class="card-head">
            <header>
              Sto cercando..
            </header>
            <div class="tools" v-if="packDetailFree_ === 1">
              <span style="padding: 3px">
                <strong style="color: red">N.B.</strong> Per la version Free i
                risultati di <strong>idealista.it</strong> sono limitati
              </span>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div
                  class="abtg__alertbox"
                  v-show="showAlert && instantShowAlert"
              >
                <strong>Attenzione</strong>. La ricerca sui portali non
                sostituisce in alcun modo la scelta ponderata dell'immobile da
                includere nella mappatura. Si consiglia sempre di controllare
                nel dettaglio i dati inseriti su Real Estate Pro. I portali
                interrogati, infatti, possono contenere dati non esatti.

                <p style="margin-top: 10px">
                  <input type="checkbox" value="1" @click="hideAlert()"/>
                  <span class="small">Non mostrare più questo avviso</span>
                </p>
              </div>
            </div>

            <div v-show="!showLoadingIcon && !showCountZeroMessage">
              <div class="row">
                <div class="col">
                  <div
                      class="
                      mdl-textfield mdl-js-textfield
                      mdl-textfield--floating-label
                      getmdl-select getmdl-select__fix-height
                      select-width
                      abtg-select
                    "
                  >
                    <label
                        class="mdl-textfield__label abtg__label-select"
                        style="margin-top: -30px"
                    >{{ $t("idealista.label_rooms") }}</label
                    >
                    <select
                        class="mdl-textfield__input abtg__input abtg-select"
                        tabIndex="-1"
                        v-model="filterRooms"
                    >
                      <option value="99999">{{ $t('mapping.indifferente') }}</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5+</option>
                    </select>
                  </div>
                </div>
                <div class="col">
                  <div
                      class="
                      mdl-textfield mdl-js-textfield
                      mdl-textfield--floating-label
                      getmdl-select getmdl-select__fix-height
                      select-width
                      abtg-select
                    "
                  >
                    <label
                        class="mdl-textfield__label abtg__label-select"
                        style="margin-top: -30px"
                    >Mq
                    </label>
                    <select
                        class="mdl-textfield__input abtg__input abtg-select"
                        tabIndex="-1"
                        v-model="filterMq"
                    >
                      <option value="0">{{ $t('mapping.indifferente') }}</option>
                      <option value="50">0 - 50</option>
                      <option value="51">51 - 90</option>
                      <option value="91">91 - 120</option>
                      <option value="121">Oltre 120</option>
                    </select>
                  </div>
                </div>

                <div class="col">
                  <div
                      class="
                      mdl-textfield mdl-js-textfield
                      mdl-textfield--floating-label
                      getmdl-select getmdl-select__fix-height
                      select-width
                      abtg-select
                    "
                  >
                    <label
                        class="mdl-textfield__label abtg__label-select"
                        style="margin-top: -30px"
                    >Prezzo
                    </label>
                    <select
                        class="mdl-textfield__input abtg__input abtg-select"
                        tabIndex="-1"
                        v-model="filterPrice"
                    >
                      <option value="999999999999999">{{ $t('mapping.indifferente') }}</option>
                      <option value="200000">fino a 200000</option>
                      <option value="400000">fino a 400000</option>
                      <option value="600000">fino a 600.000</option>
                      <option value="800000">fino a 800.000</option>
                    </select>
                  </div>
                </div>
              </div>
              <hr/>
            </div>

            <div class="row">
              <div class="col">
                <div v-if="showLoadingIcon">
                  <div style="margin-top: 30px">
                    <!-- <p class="text-center">
											<i class="fas fa-sync fa-spin fa-3x"
											   style="color:#EF7621"></i>
										</p> -->
                    <p class="text-center">Sto cercando...</p>
                    <k-progress
                        :percent="loadingBarData.percentage"
                        active
                        color="#EF7621"
                        :state="loadingBarData.state || null"
                    ></k-progress>
                  </div>
                </div>

                <div v-if="showCountZeroMessage">
                  <p class="text-center">
                    {{ $t('mapping.alert_end') }}
                  </p>
                </div>

                <div
                    class="row"
                    v-if="!showLoadingIcon && !showCountZeroMessage"
                >
                  <div class="col">
                    <span
                        class="abtg-cursor-pointer mdl-chip mdl-chip--contact"
                        :class="activeAll"
                        @click="setWebSite('')"
                    >
                      <span
                          class="
                          mdl-chip__contact
                          mdl-color--teal
                          mdl-color-text--white
                          abtg-chip
                        "
                      >{{ totBuildings }}</span
                      >
                      <span class="mdl-chip__text">{{ $t('mapping.totale_immobili') }}</span>
                    </span>

                    <span v-if="userCountry === 1">
                      <span
                          class="abtg-cursor-pointer mdl-chip mdl-chip--contact"
                          :class="activeIdealista"
                          @click="setWebSite('idealista.it')"
                      >
                        <span
                            class="mdl-chip__text"
                            style="padding-left: 10px; padding-right: 5px"
                        >{{ idealistaCount }}/{{
                            totBuildings
                          }}
                          idealista.it</span
                        >
                      </span>
                      <span
                          class="abtg-cursor-pointer mdl-chip mdl-chip--contact"
                          :class="activeImmobiliare"
                          @click="setWebSite('immobiliare.it')"
                      >
                        <span
                            class="mdl-chip__text"
                            style="padding-left: 10px; padding-right: 5px"
                        >{{ immobiliareCount }}/{{
                            totBuildings
                          }}
                          immobiliare.it</span
                        >
                      </span>
                      <span  class="abtg-cursor-pointer mdl-chip mdl-chip&#45;&#45;contact"
                               :class="activeRemax"
                                @click="setWebSite('remax.it')">
                         <span  class="mdl-chip__text"
                                   style="padding-left: 10px; padding-right: 5px">
                                 {{ remaxCount }}/{{ totBuildings }} remax.it
                         </span>

                      </span>
                    </span>

                    <span v-if="userCountry === 2">
                      <span
                          class="abtg-cursor-pointer mdl-chip mdl-chip--contact"
                          :class="activePisos"
                          @click="setWebSite('pisos.com')"
                      >
                        <span
                            class="mdl-chip__text"
                            style="padding-left: 10px; padding-right: 5px"
                        >{{ pisosCount }}/{{ totBuildings }} pisos.com</span
                        >
                      </span>
                      <span
                          class="abtg-cursor-pointer mdl-chip mdl-chip--contact"
                          :class="activeFotocasa"
                          @click="setWebSite('fotocasa.es')"
                      >
                        <span
                            class="mdl-chip__text"
                            style="padding-left: 10px; padding-right: 5px"
                        >{{ fotocasaCount }}/{{
                            totBuildings
                          }}
                          fotocasa.es</span
                        >
                      </span>
                    </span>
                  </div>
                  <hr/>
                </div>

                <div
                    class="table-responsive"
                    v-if="!showLoadingIcon && !showCountZeroMessage"
                >
                  <table
                      class="
                      mdl-data-table
                      ml-table-striped ml-table-bordered
                      mdl-js-data-table
                      is-upgraded
                    "
                  >
                    <thead>
                    <tr>
                      <th class="mdl-data-table__cell--non-numeric text-left">
                        N.
                      </th>
                      <th class="mdl-data-table__cell--non-numeric text-left">
                        {{ $t('mapping.label_image') }}
                      </th>

                      <th class="mdl-data-table__cell--non-numeric text-left">
                        {{ $t('mapping.label_address') }}

                      </th>
                      <th class="mdl-data-table__cell--non-numeric text-left">
                        {{ $t('mapping.label_floor') }}
                      </th>
                      <th class="mdl-data-table__cell--non-numeric text-left">
                        {{ $t('mapping.label_mq') }}
                        <i
                            class="
                              fas
                              fa-sort-amount-up
                              abtg__label-color-custom
                            "
                            @click="handlingSort('mq')"
                            v-show="sortUpMq === false"
                        ></i>
                        <i
                            class="
                              fas
                              fa-sort-amount-down
                              abtg__label-color-custom
                            "
                            @click="handlingSort('mq')"
                            v-show="sortUpMq === true"
                        ></i>
                      </th>
                      <th class="mdl-data-table__cell--non-numeric text-left">
                        {{ $t('mapping.label_room') }}
                      </th>
                      <th class="mdl-data-table__cell--non-numeric text-left">
                        {{ $t('mapping.label_bathroom') }}
                      </th>

                      <th class="mdl-data-table__cell--non-numeric text-left">
                        {{ $t('mapping.label_price') }}
                        <i
                            class="
                              fas
                              fa-sort-amount-up
                              abtg__label-color-custom
                            "
                            @click="handlingSort('price')"
                            v-show="sortUp === false"
                        ></i>
                        <i
                            class="
                              fas
                              fa-sort-amount-down
                              abtg__label-color-custom
                            "
                            @click="handlingSort('price')"
                            v-show="sortUp === true"
                        ></i>
                      </th>
                      <th class="mdl-data-table__cell--non-numeric text-left">
                        <input type="checkbox" @click="selectAll"/>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(building, index) in filtered">
                      <td :id="index+1" :class="isAlreadyImported(building.link)||isClone(building.clone)">
                        {{ index + 1 }}
                      </td>
                      <td :class="isAlreadyImported(building.link)||isClone(building.clone)">
                        <a :href="building.link" target="_blank"
                        ><img
                            :src="building.image"
                            class="img-thumbnail"
                            width="150"
                        /></a>
                      </td>
                      <td :class="isAlreadyImported(building.link)||isClone(building.clone)">
                        <div
                            v-if="isAlreadyImported(building.link)"
                            class="alert alert-warning"
                            style="font-size: 80%"
                        >
                          {{ $t('mapping.immobile_gia_importato') }}
                          <br/>
                          {{ $t('mapping.prezzo_diverso') }}
                          <span
                              v-if="
                                isPriceDifferent(
                                  building.price,
                                  building.link
                                ) > 0
                              "
                          >
                              {{ $t('mapping.diverso') }}: €
                              <strong>{{
                                  isPriceDifferent(building.price, building.link)
                                }}</strong>
                            </span>
                          <span v-else> {{ $t('mapping.lostesso') }}. </span>
                        </div>

                        <div
                            v-if="isClone(building.clone)"
                            class="alert alert-warning"
                            style="font-size: 80%"
                        >
                          {{ $t('mapping.doppione') }}
                          <br/>
                          <a :href="'#'+ (building.twin+1)">{{ $t('mapping.doppione_vai') }}</a>

                        </div>
                        {{ building.title }}<br/>

                        <em>Zona: {{ building.zone }}</em
                        ><br/>
                        <a :href="building.link" target="_blank"
                        >{{ $t('mapping.vai_al_dettaglio') }}
                          <strong>{{ building.website }} </strong>
                        </a>
                      </td>
                      <td :class="isAlreadyImported(building.link)||isClone(building.clone)">
                        {{ building.floor }}
                      </td>
                      <td :class="isAlreadyImported(building.link)||isClone(building.clone)">
                        {{ building.mq }}
                      </td>
                      <td :class="isAlreadyImported(building.link)||isClone(building.clone)">
                        {{ building.rooms }}
                      </td>
                      <td :class="isAlreadyImported(building.link)||isClone(building.clone)">
                        {{ building.bathroom }}
                      </td>

                      <td :class="isAlreadyImported(building.link)||isClone(building.clone)">
                        <strong>{{ building.price }}</strong>
                      </td>
                      <td :class="isAlreadyImported(building.link)||isClone(building.clone)">
                        <div class="btn-group" role="group">
                          <input
                              type="checkbox"
                              :value="building.link"
                              v-model="checkedBuildings_"
                          />
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div
              class="card-footer"
              v-if="!showLoadingIcon && !showCountZeroMessage"
          >
            <p class="float-right">
              <button
                  type="submit"
                  class="
                  btn btn-block
                  abtg__default-button
                  m-t-20
                  abtg__btn-star
                  shadow-none
                "
                  @click="onImportData()"
                  style="font-size: 100%"
              >
                {{ $t('mapping.button_import') }}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mixin} from '@/helpers/helper'
import NBread from '@/partials/bread'
import NGmap from '@/partials/mapping/gmap'
import {mapActions, mapMutations, mapState} from 'vuex'
import Modal_search_alert from '../../partials/mapping/modal_search_alert'

export default {
  mixins: [mixin],
  components: {
    Modal_search_alert,
    NGmap,
    NBread,
  },
  data() {
    return {
      pathBack: '',
      filterRooms: 99999,
      filterMq: 0,
      filterPrice: 999999999999999,
      sortUpMq: false,
      sortUp: false,
      priorityPrice: false,
      priorityMq: false,
      isAllSelected: false,
      checkedBuildings_: [],
      websiteChoosen: null,
      activeIdealista: null,
      activeImmobiliare: null,
      activeRemax: null,
      activeCasa: null,
      activePisos: null,
      activeFotocasa: null,
      activeAll: 'abtg-activeChip',
    }
  },
  created() {
    this.lang = window.localStorage.getItem("language");
    if (this.lang === "es") {
      this.SET_DATA({
        name: "bread_active",
        data: {label: "Mapeo y escaneo de mercado"},
      });
    } else {
      this.SET_DATA({
        name: 'bread_active',
        data: {label: 'Mappatura e Scan di Mercato'}
      });
    }

    this.zoneData({zoneId: this.$route.params.zoneId})
    this.counterMap()
    this.packDetailFree()
  },
  watch: {
    zoneSaved(oldValue, newValue) {
      if (oldValue != newValue) {
        this.$router.push({
          name: 'N_Mapping', params: {zone_id: this.zoneInfo.id}
        })
      }
    },

    showSearchAlertModal(val) {
      if (val) {
        this.$modal.show('m-search-alert')
      }
    },
  },
  computed: {
    ...mapState('n_mapping', [
      'bread_active',
      'bread_list',
      'zoneInfo',
      'componentKey',
      'showCard',
      'packDetailFree_',
      'counterMap_',
      'showCountZeroMessage',
      'showLoadingIcon',
      'buildingList',
      'alreadyImported',
      'toDelete',
      'checkedBuildings',
      'searchType',
      'origin',
      'zoneSaved',
      'buildingTypes',
      'instantShowAlert',
      'showSearchAlertModal',
      'userCountry',
      'loadingBarData',
      'isZoneUpdateAlert',
      'monthlyCounter',
      'monthlyZoneCounter',
      'isWalletFull',
        'checkBoxWallet'
    ]),

    filtered() {
      let self = this
      let bb = this.buildingList.filter(function (p) {
        p.price = mixin.methods.REMOVE_DOT_AND_COMMA(p.price)
        let r = ''

        let prefixQuery = 'p.link.length > 0 '
        // ROOMS
        if (parseInt(self.filterRooms) !== 99999) {
          if (parseInt(self.filterRooms) === 5) {
            r = r + ' && parseInt(p.rooms) >= parseInt(self.filterRooms)'
          } else {
            r = r + ' && parseInt(p.rooms) === parseInt(self.filterRooms)'
          }
        }

        // website
        if (self.websiteChoosen) {
          r = r + ' && p.website == self.websiteChoosen'
        }

        // Price
        if (parseInt(self.filterPrice) !== 999999999999999) {
          r = r + ' && parseInt(p.price) <= parseInt(self.filterPrice)'
        }

        // MQ
        if (parseInt(self.filterMq) !== 0) {
          if (parseInt(self.filterMq) === 50) {
            r = r + ' && parseInt(p.mq) > 0 && parseInt(p.mq) <= 50'
          }

          if (parseInt(self.filterMq) === 51) {
            r = r + ' && parseInt(p.mq) >= parseInt(self.filterMq) && parseInt(p.mq) <= 90'
          }

          if (parseInt(self.filterMq) === 91) {
            r = r + ' && parseInt(p.mq) >= parseInt(self.filterMq) && parseInt(p.mq) <= 120'
          }

          if (parseInt(self.filterMq) === 121) {
            r = r + '&& parseInt(p.mq) >= parseInt(self.filterMq) && parseInt(p.mq) <= 99999'
          }
        }

        if (r.length > 0) {
          return eval(prefixQuery + r)
        }

        return p
      })

      return bb.sort(function (a, b) {
        if (self.priorityPrice === true) {
          return self.sortUp === true ? b.price - a.price : a.price - b.price
        }

        if (self.priorityMq === true) {
          return self.sortUpMq === true ? b.mq - a.mq : a.mq - b.mq
        }
      })
    },
    totBuildings: function () {
      return (
          this.casaCount + this.immobiliareCount + this.idealistaCount + this.pisosCount + this.fotocasaCount + this.remaxCount
      )
    },

    remaxCount: function () {
      let onlyThisWebSite = this.buildingList.filter(p => p.website == 'remax.it')
      return onlyThisWebSite.length
    },

    immobiliareCount: function () {
      let onlyThisWebSite = this.buildingList.filter(p => p.website == 'immobiliare.it')
      return onlyThisWebSite.length
    },

    casaCount: function () {
      let onlyThisWebSite = this.buildingList.filter(p => p.website == 'casa.it')
      return onlyThisWebSite.length
    },
    idealistaCount() {
      let onlyThisWebSite = this.buildingList.filter(p => p.website == 'idealista.it')
      return onlyThisWebSite.length
    },

    pisosCount: function () {
      let onlyThisWebSite = this.buildingList.filter(p => p.website == 'pisos.com')
      return onlyThisWebSite.length
    },
    fotocasaCount() {
      let onlyThisWebSite = this.buildingList.filter(p => p.website == 'fotocasa.es')
      return onlyThisWebSite.length
    },
    showAlert() {
      if (localStorage.getItem('showAlert') === '1') {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    ...mapActions('n_mapping', [
      'zoneData',
      'counterMap',
      'packDetailFree',
      'searchGoogleMap',
      'prepareDataToSend',
      'importData',
      'checkCreditWallet',
    ]),
    ...mapMutations('n_mapping', ['SET_DATA']),

    isAlreadyImported(link) {
      let pos = this.alreadyImported
          .map(function (e) {
            return e.link
          })
          .indexOf(link)
      if (pos > 0) {
        return 'abtg__td-alreadyimported'
      }
    },
    isClone(clone) {
      if (clone == 1) {
        return 'abtg__td-isclone'
      }
    },
    handlingSort: function (what) {
      switch (what) {
        case 'price':
          this.priorityPrice = true
          this.priorityMq = false
          this.sortUp = !this.sortUp
          this.sortUpMq = false
          break
        case 'mq':
          this.priorityPrice = false
          this.priorityMq = true
          this.sortUpMq = !this.sortUpMq
          this.sortUp = false
          break
      }
    },

    selectAll() {
      this.isAllSelected = !this.isAllSelected
      if (this.isAllSelected === true) {
        this.filtered.forEach(value => {
          this.checkedBuildings_.push(value.link)
        })
      } else {
        this.checkedBuildings_ = []
      }
    },
    onImportData: function () {
      this.importData(this.checkedBuildings_)
    },

    isPriceDifferent(price, link) {
      let priceToCompare = 0
      this.alreadyImported.map(e => {
        if (e.link === link) {
          priceToCompare = e.prezzo
        }
      })
      if (priceToCompare > 0 && parseInt(priceToCompare) !== parseInt(price)) {
        return priceToCompare
      }
    },

    checkCredit() {
      this.checkCreditWallet();
    },

    setWebSite(website) {
      this.websiteChoosen = website
      switch (website) {
        case 'idealista.it':
          this.activeIdealista = 'abtg-activeChip'
          this.activeImmobiliare = null
          this.activeCasa = null
          this.activeRemax = null
          this.activePisos = null
          this.activeFotocasa = null
          this.activeAll = null
          break
        case 'immobiliare.it':
          this.activeImmobiliare = 'abtg-activeChip'
          this.activeIdealista = null
          this.activeCasa = null
          this.activeRemax = null
          this.activePisos = null
          this.activeFotocasa = null
          this.activeAll = null
          break
        case 'remax.it':
          this.activeRemax = 'abtg-activeChip'
          this.activeCasa = null
          this.activeImmobiliare = null
          this.activeImmobiliare = null
          this.activePisos = null
          this.activeFotocasa = null
          this.activeAll = null
          break
        case 'casa.it':
          this.activeCasa = 'abtg-activeChip'
          this.activeImmobiliare = null
          this.activeImmobiliare = null
          this.activeRemax = null
          this.activePisos = null
          this.activeFotocasa = null
          this.activeAll = null
          break
        case 'pisos.com':
          this.activePisos = 'abtg-activeChip'
          this.activeImmobiliare = null
          this.activeIdealista = null
          this.activeRemax = null
          this.activeCasa = null
          this.activeFotocasa = null
          this.activeAll = null
          break
        case 'fotocasa.es':
          this.activeFotocasa = 'abtg-activeChip'
          this.activeCasa = null
          this.activeImmobiliare = null
          this.activeRemax = null
          this.activeImmobiliare = null
          this.activePisos = null
          this.activeAll = null
          break
        case '':
          this.activeAll = 'abtg-activeChip'
          this.activeImmobiliare = null
          this.activeImmobiliare = null
          this.activeRemax = null
          this.activeCasa = null
          this.activePisos = null
          this.activeFotocasa = null
          break
      }
    },

    closeAndResetModal() {
      this.$modal.hide('m-search-alert')
      this.SET_DATA({
        name: 'showSearchAlertModal', data: false
      })
    },
  },
}
</script>
